// Authentication routes
import LoginForm from '../../components/Login.vue'

export default [
  {
    path: '/',
    name: 'Login',
    component: LoginForm,
    meta: { 
      requiresAuth: false,
      title: 'Login'
    }
  }
] 